import { Component, Input } from '@angular/core';
import { ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule, ClrModalModule } from "@clr/angular";
import { NgIf } from "@angular/common";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { UploadComponent } from "../../../../core/upload/upload.component";
import { AlertService, FileStoreService, IAlertType } from "../../../../_shared/services";
import { ClarityIcons, timesCircleIcon } from "@cds/core/icon";
import { saveAs } from "file-saver";
import { Files } from "../../../../_shared/interfaces";
import { filesBaseUrl } from "../../../../_shared/utils/rest-url";
import { getTenantStorage } from '../../../../_shared/utils/tenant-context';

import { environment as env } from "../../../../../environments/environment";

@Component({
  selector: 'app-notification-details-documents',
  standalone: true,
  imports: [
    ClrDatagridModule,
    ClrIconModule,
    ClrModalModule,
    NgIf,
    NgxExtendedPdfViewerModule,
    UploadComponent
  ],
  templateUrl: './notification-details-documents.component.html',
  styleUrl: './notification-details-documents.component.sass'
})
export class NotificationDetailsDocumentsComponent {
  notificationFiles: Files[] = [];
  public showPdf = false;
  public showFileUpload = false;
  modalContent: string = '';
  modalUrl: string = '';
  public loading: boolean = true;
  descSort = ClrDatagridSortOrder.DESC;

  @Input() projectId: string = '';
  @Input() jobId: number = 0;
  @Input() notificationId: number = 0;
  @Input() documentType: number = 0;

  private filesDirectory = filesBaseUrl();

  @Input() offerNumber: number = 0;

  constructor(
    private alertDispatcher: AlertService,
    private fileService: FileStoreService,
  ) {
    ClarityIcons.addIcons(timesCircleIcon)
  }

  ngOnInit() {
    this.getFilesSet([this.documentType], this.projectId);
  }

  showModal(fileId: string) {
    const phmToken = getTenantStorage('access_token');
    this.modalUrl = `${this.filesDirectory}/download_file?file_id=${fileId}&token=${phmToken}`;
    this.showPdf = true;
  }

  closeModal(state: boolean) {
    this.showFileUpload = state;
    this.loading = true;
    this.getFilesSet([this.documentType], this.projectId);
  }

  showFileUploader() {
    this.showFileUpload = true;
  }

  private getFilesSet(docType: number[], projectId: string) {
    this.fileService.getFilesSet(docType, projectId, 0, this.notificationId).subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.notificationFiles = [];
          this.alertDispatcher.alertConfig.message = 'Keine Dateien gefunden!';
          this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
          return;
        }
        this.notificationFiles = data.object;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return}
    })
  }

  deleteFile(fileId: string, fileName: string) {
    if (confirm('Wollen Sie die Datei ' + fileName + ' wirklich löschen?\nDiese Aktion kann nicht rückgängig gemacht werden!')) {
      this.fileService.deleteFile(fileId)
        .subscribe({
          next: () => {
            this.notificationFiles = this.notificationFiles.filter(file => file.id !== fileId);
            this.alertDispatcher.alertConfig.message = 'Datei ' + fileName + ' wurde gelöscht. ';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.DANGER;
          },
          complete: () => {
            this.getFilesSet([this.documentType], this.projectId);
          },
          error: () => {
            return
          }
        })
    }
  }

  loadFile(fileId: string, fileName: string) {
    if (confirm('Wollen Sie die Datei ' + fileName + ' herunterladen?')) {
      this.fileService.downloadFile(fileId)
        .subscribe({
          next: data => {
            if (!data) {
              this.alertDispatcher.alertConfig.message = 'Keine Datei gefunden!';
              this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
              return;
            }
            saveAs(data, fileName);
          },
          complete: () => {
            this.alertDispatcher.alertConfig.message = 'Datei ' + fileName + ' wurde heruntergeladen. ';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.INFO;
          },
          error: () => {
            return
          }
        })
    }
  }
}
